(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("Vue"), require("VueI18n"), require("VueRouter"), require("window._"));
	else if(typeof define === 'function' && define.amd)
		define(["Vue", "VueI18n", "VueRouter", "window._"], factory);
	else if(typeof exports === 'object')
		exports["pc-gateway-index"] = factory(require("Vue"), require("VueI18n"), require("VueRouter"), require("window._"));
	else
		root["pc-gateway-index"] = factory(root["Vue"], root["VueI18n"], root["VueRouter"], root["window._"]);
})(self, function(__WEBPACK_EXTERNAL_MODULE__62508__, __WEBPACK_EXTERNAL_MODULE__67620__, __WEBPACK_EXTERNAL_MODULE__48533__, __WEBPACK_EXTERNAL_MODULE__57971__) {
return 